<form novalidate [formGroup]="formData" (submit)="handleSubmit($event)">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="" [translate]="'ACCOUNT.FIRSTNAME'">Firstname</label>
          <input class="form-control" type="text" formControlName="firstname" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.firstname"
          >
          </control-messages>
        </div>

        <div class="form-group">
          <label for="" [translate]="'ACCOUNT.LASTNAME'">Lastname</label>
          <input class="form-control" type="text" formControlName="lastname" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.lastname"
          >
          </control-messages>
        </div>

        <div class="form-group">
          <label for="" [translate]="'CONTACT.MOBILE'">Mobile</label>
          <input class="form-control" type="text" formControlName="mobile" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.mobile"
          >
          </control-messages>
        </div>

        <div class="form-group">
          <label for="" [translate]="'CONTACT.PHONE'">Phone</label>
          <input class="form-control" type="text" formControlName="phone" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.phone"
          >
          </control-messages>
        </div>

        <div *ngIf="loginUser.role == 88 || loginUser.role == 99">
          <div class="form-group">
            <mat-checkbox
              color="primary"
              formControlName="receive_payment_due_notif"
            >
              Receive purchase order notifications
            </mat-checkbox>
          </div>

          <div class="form-group">
            <mat-checkbox color="primary" formControlName="prwx">
              View only account
            </mat-checkbox>
          </div>

          <div class="form-group">
            <mat-checkbox color="primary" formControlName="po_approval_permission">
              Can approve B2B Client 'For Approval' Purchase Orders
            </mat-checkbox>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" [translate]="'ACCOUNT.LOGIN_EMAIL'">Login Email</label>
          <input class="form-control" type="email" formControlName="email" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.email"
          >
          </control-messages>
        </div>

        <div class="form-group" *ngIf="!staff">
          <label for="" [translate]="'FORM.INPUT.PASSWORD'">Password</label>
          <div class="input-group">
            <input
              class="form-control"
              [type]="hide ? 'password' : 'text'"
              formControlName="password"
            />
            <div class="input-group-append">
              <button class="btn btn-secondary btn-sm" type="button">
                <mat-icon (click)="hide = !hide"
                  >{{ hide ? 'visibility_off' : 'visibility' }}
                </mat-icon>
              </button>
            </div>
          </div>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.password"
            [minlength]="8"
          >
          </control-messages>
        </div>

        <div *ngIf="loginUser.role == 99">
          <div class="form-group" *ngIf="loginUser.is_admin == 1">
            <label for="" [translate]="'ACCOUNT.USER_ROLE'">Staff Role</label>
            <select class="form-control" formControlName="role">
              <option *ngFor="let role of roles" [value]="role.role_id">
                {{ role.role }}
              </option>
            </select>
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.role"
            >
            </control-messages>
          </div>
          <div
            class="form-group"
            *ngIf="loginUser.is_admin == 1 && formData.value.role == 1"
          >
            <label for="" [translate]="'FACTORY.FACTORY_ADMIN'"
              >Factory Admin</label
            >
            <select
              class="form-control text-capitalize"
              formControlName="parent_id"
            >
              <option
                class="text-capitalize"
                *ngFor="
                  let staff of staffService.staff$ | async | filterBy: ['role'] : 8
                "
                [value]="staff.id"
              >
                {{ staff.firstname }} {{ staff.lastname }}
              </option>
            </select>
            <control-messages
              [submitted]="submitted"
              [control]="formData.controls.parent_id"
            >
            </control-messages>
          </div>
        </div>

        <!-- <div class="form-group" *ngIf="formData.value.role<88">
                    <label for="">GMV Commission Rate</label>
                    <input class="form-control" type="text" formControlName="com_gmv" />
                    <control-messages [submitted]="submitted" [control]="formData.controls.com_gmv"> </control-messages>
                </div>

                <div class="form-group" *ngIf="formData.value.role==2">
                    <label for="">Subscription Commission Rate</label>
                    <input class="form-control" type="text" formControlName="com_sub" />
                    <control-messages [submitted]="submitted" [control]="formData.controls.com_sub"> </control-messages>
                </div> -->
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="submit"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-primary btn-elevate kt-btn-primary"
      [translate]="'BUTTONS.SAVE'"
    >
      <i class="fas fa-save"></i> Save
    </button>
  </div>
</form>
